if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer') && this.submitButton) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        // Always re-query the cart drawer at submit time
        this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        const spinner = this.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        const formData = new FormData(this.form);
        const variantId = formData.get('id');
        const quantity = parseInt(formData.get('quantity')) || 1;

        // Step 1: Add item to cart (use .js endpoint to guarantee JSON response)
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({ id: parseInt(variantId), quantity: quantity }),
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            this.error = false;

            return Promise.all([
              fetch(`${routes.cart_url}?section_id=cart-drawer&sections_url=${encodeURIComponent(window.location.pathname)}`).then(r => r.text()),
              fetch(`${routes.cart_url}?section_id=cart-icon-bubble`).then(r => r.text()),
            ]);
          })
          .then((sections) => {
            if (!sections || !this.cart) return;

            const [drawerHTML, bubbleHTML] = sections;

            // Update cart drawer content
            const drawerParsed = new DOMParser().parseFromString(drawerHTML, 'text/html');
            const newDrawerInner = drawerParsed.querySelector('#CartDrawer');
            const currentDrawer = document.getElementById('CartDrawer');
            if (newDrawerInner && currentDrawer) {
              currentDrawer.innerHTML = newDrawerInner.innerHTML;
            }

            // Update cart icon bubble
            const bubbleParsed = new DOMParser().parseFromString(bubbleHTML, 'text/html');
            const newBubble = bubbleParsed.querySelector('.shopify-section');
            const currentBubble = document.getElementById('cart-icon-bubble');
            if (newBubble && currentBubble) {
              currentBubble.innerHTML = newBubble.innerHTML;
            }

            // Remove empty state and open drawer
            this.cart.classList.remove('is-empty');
            const inner = this.cart.querySelector('.drawer__inner');
            if (inner) inner.classList.remove('is-empty');

            // Re-bind overlay and open
            const overlay = this.cart.querySelector('#CartDrawer-Overlay');
            if (overlay) overlay.addEventListener('click', () => this.cart.close());
            
            this.cart.open();

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
            });
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            const spinner = this.querySelector('.loading__spinner');
            if (spinner) spinner.classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
